export default __webpack_public_path__ + "static/media/Partner22.ec21e32b.jpeg";